import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CommunicationService} from '../../../services/communication.service';
import {ListingCategory} from '../../../classes/enums';

@Component({
  selector: 'app-drawer-page',
  templateUrl: './drawer-page.component.html',
  styleUrls: ['./drawer-page.component.scss']
})
export class DrawerPageComponent {
  ListingCategory = ListingCategory;

  constructor(
    private communicationService: CommunicationService) {
  }

  @Input() enableCloseButton: boolean = false;
  @Input() enableApplyButton: boolean = false;
  @Input() title: string;
  @Input() currentShownListingType: ListingCategory;
  @Output() closed = new EventEmitter<void>();

}
